module.exports = __webpack_public_path__ + "static/4.2_550x380_Doctor_Patient_Desktop_1X-9366b6c603331e28d7c846e4678e7eaa.png";